export default {
  primary: '#a1ae39',
  secondary: '#383a3e',
  promo1: '#5a4185',
  promo2: '#3e5da3',
  promo3: '#69bade',
  promo4: '#3f797e',
  promo5: '#009f70',
  promo6: '#80c342',
  promo7: '#e3305e',
  promo8: '#f47932',
  promo9: '#e9ae21',
  promo10: '#ffcf31',
  gray: '#aaa',

  herbarium_records: '#e3305e',
  specialZones: '#adff2f',
  recommended_collection_area: '#333',
  similar_environments_current: '#6336b0',
  similar_environments_future: '#ff6d00' //'#ff8a65'   //  '#ff9100' //'#e23ca8'
}



// WEBPACK FOOTER //
// ./src/Theme.js